import React, { Component } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import './TendersPage.css';

const TendersPage = props => (

		<section className="container work-section" id="work">    
			<Row>
				<Col className="center title">
					<h2>Przetargi</h2>
				</Col>
			</Row>
         <div className="project-about" id="about">
            <img className="loga-about" src="loga_gotowe.jpg" alt="loga" />
            <p>
               Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą inwestycji technologicznej
               polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food.
            </p>
            <p>
               Celem przedsięwzięcia jest trwała poprawa konkurencyjności przedsiębiorstwa HADEPOL FLEXO Sp. z o.o. na krajowym
               i zagranicznym rynku opakowań poprzez wdrożenie innowacji technologicznych w obszarze wytwarzania opakowań papierowych powlekanych.
               Efektem realizacji projektu będzie wdrożenie innowacji procesowej nie znanej do tej pory na świecie oraz zupełnie nowego produktu
               o nieznanym dotąd poziomie użytkowym. Zakres rzeczowy projektu obejmuje nakłady inwestycyjne związane
               z zakupem następujących nowych środków trwałych:
               1. Linia technologiczna do produkcji opakowań.
            </p>
            <p>
               Projekt pozwoli znacząco poszerzyć ofertę produktową i technologiczną przedsiębiorstwa, co zostanie osiągnięte drogą
               praktycznego zastosowania innowacyjnych rozwiązań w zakresie produkcji opakowań papierowych o unikalnej konstrukcji
               i podwyższonych walorach użytkowych.Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą
               inwestycji technologicznej polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food."
            </p>
            <p>
               Wartość projektu : 10 380 499,20 PLN<br />
               Wkład Funduszy Europejskich : 4 671 224,66 PLN
            </p>
          </div>
         <div className="tenders-box">
            <div className="tender-box">
               <span>29.08.2018 - </span>
               <a href="http://hadepol.com.pl/zawiadomienie_o_rozstrzygnieciu_ofert.pdf" target="__blank">Zawiadomienie o rozstrzygnięciu ofert w ramach projektu:…</a>
            </div>
            <div className="tender-box">
               <span>17.07.2018 - </span>
               <a href="http://hadepol.com.pl/Zapytanie_ofertowe_nr_2.2018.pdf">Zapytanie ofertowe nr 2/2018…</a>
            </div>
            <div className="tender-box">
               <span>30.06.2018 - </span>
               <a href="http://hadepol.com.pl/zawiadomienienr2.pdf">Zawiadomienie o rozstrzygnięciu ofert w ramach projektu:…</a>
            </div>
            <div className="tender-box">
               <span>30.05.2018 - </span>
               <a href="https://bazakonkurencyjnosci.funduszeeuropejskie.gov.pl/publicationproposal/view/4987"> Linia technologiczna do produkcji opakowań składającej się z 3 modułów – maszyn: powlekająco – rozcinającej, drukującej i formującej materiał w gotowe opakowanie – torebki</a>
            </div>
         </div>
         <div className="image-przetargi-box">
            <img className="image-przetargi" src="przetargi.jpg" />
         </div>
        </section>
	);

export default TendersPage;